import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

const state = {
  isPosting: false,
  RECAPTCHA_ID: '',
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
